import { createFileRoute } from "@tanstack/react-router";
import IsTmsAMedication from "@/pages/articles/IsTmsAMedication";
export const Route = createFileRoute("/is-tms-a-medication")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Is TMS A Medication | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS is not a medication. It’s a non-drug, non-invasive brain stimulation therapy. Learn how TMS and SAINT TMS work for depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Is TMS A Medication | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS is not a medication. It’s a non-drug, non-invasive brain stimulation therapy. Learn how TMS and SAINT TMS work for depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/is-tms-a-medication",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/is-tms-a-medication",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IsTmsAMedication />;
}
